
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iao-valley/faq",
      function () {
        return require("private-next-pages/iao-valley/faq.js");
      }
    ]);
  